// React Component (or JSX)

import React from 'react';
import './App.css'; // Assuming you have a CSS file for styles

const MilesCranmerPR_JuliaNLSolvers_Optim_jl_pull_1084_From_2025_03_01_To_2025_03_31_Create_benchmark_suite = () => {
  return (
    <>
     <a
        href="https://github.com/MilesCranmer?tab=overview&from=2025-03-01&to=2025-03-31"
        target="_blank"
        rel="noopener noreferrer"
      >
        Overview of commits/PRs from Mar 1, 2025 to Mar 31, 2025
      </a>
<div>
<a
        href="https://github.com/MilesCranmer?tab=overview&from=2025-03-01&to=2025-03-31"
        target="_blank"
        rel="noopener noreferrer"
      >
        Backend URL Link  https://github.com/MilesCranmer?tab=overview&from=2025-03-01&to=2025-03-31
      </a>
</div>
      
    
<h1 style={{ margin: 0 }}
  className="Box-sc-g0xbh4-0 clYxDg prc-Heading-Heading-6CmGO"
  data-component="PH_Title"
  data-hidden="false"
>
<bdi className="js-issue-title markdown-title">Create benchmark suite</bdi>

  <span className="Box-sc-g0xbh4-0 YJa-Di">
  <a href="https://github.com/JuliaNLSolvers/Optim.jl/pull/1084" target="_blank" rel="noopener noreferrer">
  #1084
    </a>
   
    </span>
</h1>

<div style={{ display: 'flex', alignItems: 'center' }}>
<a className="Box-sc-g0xbh4-0 cRhwji prc-Link-Link-85e08" 
href="https://github.com/MilesCranmer" data-hovercard-url="/users/stevengj/hovercard" data-testid="issue-body-header-author">MilesCranmer</a>

<div className="Box-sc-g0xbh4-0 bJQcYY ActivityHeader-module__footer--FVHp7"><span>commented </span>
<a className="Box-sc-g0xbh4-0 bjFvWy prc-Link-Link-85e08" href="https://github.com/JuliaNLSolvers/Optim.jl/pull/1084" 
data-testid="issue-body-header-link"><relative-time 
// sx="[object Object]" 
className="sc-aXZVg gcWyXp" 
datetime="2024-07-18T08:44:29.000Z" title="Jul 18, 2024, 2:14 PM GMT+5:30">on Mar 25, 2025</relative-time></a>

{/* <span className="MarkdownLastEditedBy-module__container--fKxHN"><span> · </span><span>edited by 
  <a className="Box-sc-g0xbh4-0 bjFvWy prc-Link-Link-85e08" href="https://github.com/stevengj">stevengj</a></span></span> */}

  </div>
</div>

<p>Here are the details of a specific commit from the <a href="https://github.com/JuliaNLSolvers/Optim.jl" target="_blank">JuliaNLSolvers/Optim.jl repository</a>:</p>
<p>Pull Request Test Coverage Report given in #1084</p>

<p dir="auto">This creates a simple benchmark for catching performance regressions on small, tightly controlled problems. To kick things off I added the multivariate first-order optimizers including 
  <code className="notranslate">Adam</code>, 
  <code className="notranslate">AdaMax</code>, 
  <code className="notranslate">BFGS</code>, 
  <code className="notranslate">LBFGS</code>, 
  <code className="notranslate">NGMRES</code>, 
<code className="notranslate">ConjugateGradient</code>, 
<code className="notranslate">GradientDescent</code>, and <code className="notranslate">MomentumGradientDescent</code>.</p>

<p dir="auto">I also add a GitHub action to run AirspeedVelocity.jl on this benchmark for any new PR. It will automatically print out the performance and load time comparison of master in a GitHub comment on the PR.</p>
<div style={{ display: 'flex', alignItems: 'center' }}>
<a className="Box-sc-g0xbh4-0 cRhwji prc-Link-Link-85e08" 
href="https://github.com/pkofod" data-hovercard-url="/users/stevengj/hovercard" data-testid="issue-body-header-author">Patrick Kofod Mogensen</a>

<div className="Box-sc-g0xbh4-0 bJQcYY ActivityHeader-module__footer--FVHp7"><span>commented </span>
<a className="Box-sc-g0xbh4-0 bjFvWy prc-Link-Link-85e08" href="https://github.com/JuliaNLSolvers/Optim.jl/pull/1084" 
data-testid="issue-body-header-link"><relative-time 
// sx="[object Object]" 
className="sc-aXZVg gcWyXp" 
datetime="2024-07-18T08:44:29.000Z" title="Jul 18, 2024, 2:14 PM GMT+5:30">on Mar 25, 2025</relative-time></a>

{/* <span className="MarkdownLastEditedBy-module__container--fKxHN"><span> · </span><span>edited by 
  <a className="Box-sc-g0xbh4-0 bjFvWy prc-Link-Link-85e08" href="https://github.com/stevengj">stevengj</a></span></span> */}

  </div>
</div>
<p dir="auto">hey, it works :) <a href="https://github.com/JuliaNLSolvers/Optim.jl/actions/runs/14055921576/job/39355263452?pr=1138">https://github.com/JuliaNLSolvers/Optim.jl/actions/runs/14055921576/job/39355263452?pr=1138</a></p>

  </>
  );
};

export default MilesCranmerPR_JuliaNLSolvers_Optim_jl_pull_1084_From_2025_03_01_To_2025_03_31_Create_benchmark_suite;
